export enum SIGNALR_STATUS {
    Connected = "connected",
    Disconnected = "disconnected",
    Connecting = "connecting"
}